<template>
  <pt-order-handle class="pt-order-handle__withData"></pt-order-handle>
</template>

<script>
import PtOrderHandle from './index'
export default {
  name: 'pt-order-handle__withData',
  components: {
    'pt-order-handle': PtOrderHandle
  }
}
</script>
